import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueRouter from 'vue-router'
import router from './router/index'
import '@/design/index.scss'
import store from '@/state/store'
import App from './App.vue'
import { initFirebaseBackend, getFirebaseAuth } from '@/helpers/authUtils'
import { default as i18n, loadLanguageAsync } from '@/helpers/i18n'
import VueApollo from 'vue-apollo'
import client from '@/helpers/apollo/clients/default'
import moment from 'moment'

console.log(moment.locale())

moment.updateLocale('en', {
  week: {
    // Set the First day of week to Monday
    dow: 1
  }
})

import vue3dLoader from 'vue-3d-loader'
Vue.use(vue3dLoader)

Vue.use(VueRouter)
Vue.config.productionTip = process.env.NODE_ENV !== 'production'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuelidate)
Vue.component('apexchart', VueApexCharts)
Vue.use(VueApollo)

Vue.use(require('vue-moment'))

require('./helpers/filters/pretty-bytes')

import GenericComponents from './components/generic'
Vue.use(GenericComponents, { prefix: 'g' })

import AppComponents from './components/app'
Vue.use(AppComponents, { prefix: 'app' })

Vue.filter('thousands', (value, decimals, min = 1000) => {
  const abbreviate = require('number-abbreviate')

  if (value >= min) {
    //anything above the minimum is abbreviated
    let number = abbreviate(value, decimals)
    return `${number}+`
  }

  return value
})

import toCurrency from './helpers/currency'
Vue.filter('toCurrency', toCurrency)
Vue.filter('currency', toCurrency)

const apolloProvider = new VueApollo({
  defaultClient: client
})

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
}

initFirebaseBackend(firebaseConfig)

console.info(
  '%c VERSION ' + process.env.VUE_APP_VERSION + ' ',
  'background: #222; color: #bada55'
)

i18n.silentTranslationWarn = true

let app
getFirebaseAuth().onAuthStateChanged(() => {
  loadLanguageAsync(i18n.fallbackLocale)
  if (!app) {
    app = new Vue({
      router,
      store,
      i18n,
      apolloProvider,
      render: h => h(App)
    }).$mount('#app')
  }
})
